import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import { Table, TableBody, TableRow } from '@material-ui/core';
import * as design from 'styles/designConstants';

import { PAGINATION_ACTIONS } from '../utils';

interface IPaginationControlProps {
  dataTestId: string;
  count: number;
  currentPage: number;
  rowsPerPage: number;
  handlePageChange: (name: any, page?: number) => void;
  isDisabledControls: boolean;
}

interface IActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onChangePage: (name: any, page: number) => void;
  isDisabledControls: boolean;
}

const useStyles = makeStyles(() => ({
  root: {
    flexShrink: 0,
  },
  caption: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0px',
    textAlign: 'left',
    color: design.designConstants.color.$grey_82,
  },
  table: {
    display: 'flex',
  },
  toolbar: {
    paddingLeft: '0px',
  },
}));

export const PaginationActions = (props: IActionsProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage, isDisabledControls } = props;

  const handleFirstPageButtonClick = () => {
    onChangePage(PAGINATION_ACTIONS.FIRST_PAGE, 0);
  };

  const handleBackButtonClick = () => {
    onChangePage(PAGINATION_ACTIONS.PREVIOUS_PAGE, page - 1);
  };

  const handleNextButtonClick = () => {
    onChangePage(PAGINATION_ACTIONS.NEXT_PAGE, page + 1);
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={isDisabledControls || page === 0}
        aria-label="first page"
        data-testid="first-page"
        name="first"
        size="medium"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        aria-label="previous page"
        name="prev"
        data-testid="prev-page"
        disabled={isDisabledControls || page === 0}
        onClick={handleBackButtonClick}
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        aria-label="next page"
        data-testid="next-page"
        disabled={
          isDisabledControls || page >= Math.ceil(count / rowsPerPage) - 1
        }
        onClick={handleNextButtonClick}
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </div>
  );
};

const TablePaginationControls = (props: IPaginationControlProps) => {
  const classes = useStyles();
  const {
    count,
    currentPage,
    rowsPerPage,
    handlePageChange,
    dataTestId,
    isDisabledControls,
  } = props;

  return (
    <Table data-testid={dataTestId}>
      <TableBody>
        <TableRow>
          <TablePagination
            className={classes.table}
            classes={{
              caption: classes.caption,
              toolbar: classes.toolbar,
            }}
            rowsPerPageOptions={[]}
            count={count}
            rowsPerPage={rowsPerPage}
            page={currentPage}
            onChangePage={handlePageChange}
            // eslint-disable-next-line react/no-unstable-nested-components
            ActionsComponent={(actionComponentProps: any) => (
              <PaginationActions
                {...actionComponentProps}
                isDisabledControls={isDisabledControls}
              />
            )}
          />
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default TablePaginationControls;
